'use strict';

const _=require('pulsar-utils/dist-es6/_');let

BaseController=class BaseController{
constructor(annotationService,$timeout,$scope){
annotationService.applyTo(this);
if(_.exists($timeout)){
this._triggerDigest=()=>$timeout(_.noop);
}
if(_.exists($scope)){
this._$scope=$scope;
}
}

static get type(){
return'controller';
}

_safeWatch(prop,func){
this._$scope.$watch(`controller.${prop}`,(newVal,oldVal)=>{
if(!_.exists(newVal)||newVal===oldVal){
return;
}
func(newVal,oldVal);
});
}};


module.exports=BaseController;
//# sourceMappingURL=baseController.js.map
